import { createFileRoute, Outlet } from "@tanstack/react-router";
import LandingFooter from "./_components/LandingFooter";
import LandingHeader from "./_components/LandingHeader";

export const Route = createFileRoute("/_public")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-background text-foreground font-sans flex flex-col space-y-6">
      {/* ── Nav ── */}
      <LandingHeader />

      <Outlet />

      {/* ── Footer ── */}
      <LandingFooter />
    </div>
  );
}
